import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['type', 'arType']);
  const createARItemConfig = `createARItemConfig(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createARItemConfig} {
      id
    }
  }
`;
};
